<template>
    <div class="community-page">
        <div class="banner link">
            <div class="mask">
                <img src="@/assets/images/sustainable/community/sf-01.png" alt="人才伙伴banner图片" />
            </div>
            <div class="content">
                <div class="wrap">
                    <h1>合作共赢</h1>
                    <h3><span>共建无限可能</span></h3>
                    <p class="desc">
                        顺丰作为国内领先的快递物流综合服务商，服务千家万户，致力让人与人的连接更紧密，使潜能放大，成为共创改变的原动力。
                    </p>
                </div>
            </div>
        </div>
        <div class="main-content">
            <div class="content-target">
                <h3 class="text-left">可持续发展目标</h3>
                <target-list pageName="community" :targetData="targetInfo" />
                <h3>2023年关键数据</h3>
                <ul class="data-list text-left">
                    <li class="data-item">
                        <div class="title">15.1%</div>
                        <div>百万快件人员伤亡事故率同比下降</div>
                    </li>
                    <li class="data-item">
                        <div class="title">100<sub>%</sub></div>
                        <div>安全培训覆盖率</div>
                    </li>
                    <li class="data-item">
                        <div class="title">0<sub>起</sub></div>
                        <div>重大火灾、伤亡事故</div>
                    </li>
                    <li class="data-item">
                        <div class="title">100<sub>%</sub></div>
                        <div>供应商社会责任、诚信廉洁、保密等条款签署率</div>
                    </li>
                </ul>
            </div>
            <accordion pageName="community" :cardData="employeeCardInfo" className="card-employee" theme="orange" />
            <accordion pageName="community" :cardData="customerCardInfo" className="card-customer" theme="orange" />
            <accordion pageName="community" :cardData="supplierCardInfo" className="card-supplier" theme="orange" />
            <div class="download">
                <a class="link" href="https://www.sf-express.com/uploads/2022_8a7477b59e.pdf" target="_blank">
                    <img src="@/assets/images/sustainable/download-icon.png" alt="《顺丰控股2022年可持续发展报告》" />
                    <p>下载《顺丰控股2022年度可持续发展报告》</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Accordion from './components/accordion'
import TargetList from './components/targetList'
export default {
    components: {
        Accordion,
        TargetList
    },
    data() {
        return {
            expandTargetCard: false,
            employeeCardInfo: {
                title: '成就人才队伍',
                content:
                    '顺丰致力于打造全球优秀人才追求卓越、实现理想的事业平台，秉承平等尊重、协作共赢和创新包容的“球队”文化，让员工在“比赛”中成长，实现自我价值。不仅建立了公正透明的评价体系，还从培训赋能、晋升发展、组织氛围建设等多维度持续提升薪酬竞争力和员工满意度',
                cards: [
                    {
                        smallImg: 'employee-02.png',
                        expandImg: 'employee-02-big.png',
                        title: '保护员工权益',
                        desc: '顺丰设立工会监督员工权益保障情况，倾听员工真实声音，解决员工合理诉求。截至2023年底，顺丰在全网共建立了130个工会组织，工会代表高达2.1万人',
                        expand: false
                    },
                    {
                        smallImg: 'employee-03.png',
                        expandImg: 'employee-03-big.png',
                        title: '助力员工成长',
                        desc: '顺丰秉持“人才是第一生产力”的理念，高度关注员工成长和发展。2023年优化培训体系，迭代课程及讲师管理机制；围绕关键人才队伍的实际业务场景建立需求地图并匹配课程资源，打造全流程培养机制；同时通过数字化平台支撑人才培养工作闭环管理。实现培训需求“更精准”、培训内容“有供给”、培训资源“被找到”、人才培养“有依据”。',
                        expand: false
                    },
                    {
                        smallImg: 'employee-04.png',
                        expandImg: 'employee-04-big.png',
                        title: '践行员工关爱',
                        desc: '顺丰建立了全面且多元的员工福利关爱体系，从“保障基础福利、提升关怀温度、助力长期发展”三大方面为员工提供丰富多样的福利关爱举措，帮助员工解决实际问题，提升员工归属感和幸福感，增强员工凝聚力和认同感。2023年为2万余名困难员工及家庭提供慰问帮扶，帮扶金额约1,161万元。',
                        expand: false
                    },

                    {
                        smallImg: 'employee-05.png',
                        expandImg: 'employee-05-big.png',
                        title: '保障安全生产',
                        desc: '顺丰制定年度安全管理目标，量化安全生产要求，定期回顾与检讨安全管理工作以及管理成效，其达成情况与全体管理人员绩效挂钩。公司持续追踪多项员工以及承包商的健康与安全相关定量指标。2023年，顺丰未发生重大火灾事故和重大伤亡事故，百万快件人员伤亡事故率较2022年下降15.1%。',
                        expand: false
                    }
                ]
            },
            customerCardInfo: {
                title: '打造优质服务',
                content:
                    '顺丰的服务已渗透到工业制造、商业流通、农产品上行、食品及医药冷链、国际贸易、本地生活等各个领域，覆盖社会生产及民生的方方面面。同时，积极拥抱行业新业态、新趋势，助力客户创新商业模式，提升消费者感知体验，践行美好生活的传递者、守护者。',
                cards: [
                    {
                        smallImg: 'customer-01.png',
                        expandImg: 'customer-01-big.png',
                        title: '提升客户体验',
                        desc: '顺丰始终坚持以客户为中心，不断提升服务质量和差异化服务竞争力，持续为客户提供高时效高品质服务。公司持续完善各细分领域的行业服务标准，以客户声音驱动运营全环节协同交付，推动内部服务标准流程优化，为客户提供有速度有温度的服务，不断提升客户满意度。\n在国家邮政局2023年快递服务满意度调研中，顺丰已连续第15年获得快递服务总体满意度和公众满意度第一名。',
                        expand: false
                    },
                    {
                        smallImg: 'customer-02.png',
                        expandImg: 'customer-02-big.png',
                        title: '客户隐私保护',
                        desc: '顺丰围绕下单、收派、中转等各业务环节施行全链路客户数据安全保护策略。\n公司持续推进隐私面单工作，将客户电话号码中间隐藏位数由4位提升至6位，同时支持客户差异化隐私保护需求，全方位保障客户数据与隐私安全。',
                        expand: false
                    }
                ]
            },
            supplierCardInfo: {
                title: '共建责任链条',
                content:
                    '顺丰重视供应商管理，秉持诚信担当的核心价值观，倡导建立平等、尊重、透明、发展、共赢、阳光的合作环境，多年来与供应商及合作伙伴建立了长期稳定、互利共赢的合作关系，携手共建负责任供应链。',
                cards: [
                    {
                        smallImg: 'supplier-01.jpg',
                        expandImg: 'supplier-01-big.jpg',
                        title: '供应商管理',
                        desc: '顺丰设有采购监督委员会，负责采购过程的风险监督。同时采取分级管理的模式——战略采购委员会作为战略决策组织，负责战略方向的决策与指导；常规采购委员会和IT品类采购委员会负责采购活动策略制定；下设采购供应链中心，负责执行采购决策、采购需求分析以及供应商管理工作。',
                        expand: false
                    }
                ]
            },
            targetInfo: [
                {
                    desc: '顺丰制定覆盖全公司的健康与安全目标，搭建安全管理体系并通过ISO45001认证，并从运输、中转及仓储等角度制定措施，确保员工的健康与安全。',
                    bgImg: 'goal-03.png',
                    active: false,
                    bgColor: 'rgb(76,159,56)'
                },
                {
                    desc: '顺丰为员工提供学历提升与技能认证的学费资助，并为贫困学生设立奖学金，帮助员工及弱势群体获得优质的教育资源。',
                    bgImg: 'goal-04.png',
                    active: false,
                    bgColor: 'rgb(197,25,45)'
                },
                {
                    desc: '顺丰严格贯彻男女平等的原则，禁止一切形式的歧视，持续扩大女性员工人数，并为女性员工提供专属福利关爱。',
                    bgImg: 'goal-05.png',
                    active: false,
                    bgColor: 'rgb(255,58,33)'
                },
                {
                    desc: '顺丰为退伍军人、障碍人士、在校大学生提供合适的岗位与实习机会，保障特殊群体的体面就业与职业发展。',
                    bgImg: 'goal-08.png',
                    active: false,
                    bgColor: 'rgb(162,25,66)'
                },
                {
                    desc: '顺丰坚持自主创新，在快件的收、转、运、派各个环节研发新产品，打造智慧物流，赋能行业智能化。',
                    bgImg: 'goal-09.png',
                    active: false,
                    bgColor: 'rgb(253,105,37)'
                }
                // {
                //     desc: '顺丰设定2030年碳减排目标，从快递包裹运输的各个环节减少能耗消耗，识别气候变化风险，并主动采取应对措施。',
                //     bgImg: 'goal-13.png',
                //     active: false,
                //     bgColor: 'rgb(63,126,68)'
                // }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@import './common.scss';
.wrap {
    padding-top: 0.96rem;
    padding-left: 0.8rem;
}
.community-page {
    text-align: left;
    .banner {
        height: 6rem;
    }
    .main-content {
        padding: 1rem 0.72rem;
        background-color: #e8e8e8;
        font-size: 0.3rem;
        line-height: 1.8;
        color: #000000;
        .data-list {
            padding-left: 0.44rem;
            .title {
                color: #2b489b;
            }
        }
        .mask-orange {
            background-color: #d4ac89;
        }
        .link {
            .detail-wrap {
                > h3,
                > h4 {
                    text-align: left;
                }
            }
        }
        .card {
            >>> .card-header {
                background: #d4ac89;
                .detail-wrap {
                    position: relative;
                }
                .mask {
                    display: none;
                }
            }
            &.card-employee {
                margin-top: 1rem;
                >>> .card-header .mask {
                    height: 3.3rem;
                }
            }
            &.card-customer {
                >>> .card-header .mask {
                    height: 3.3rem;
                }
            }
            &.card-supplier {
                >>> .card-header .mask {
                    height: 2.76rem;
                }
            }
            .card-body {
                text-align: left;
                .detail-wrap {
                    padding-top: 0.96rem;
                }
                .link {
                    .detail-wrap.align-center {
                        padding: 0 0.44rem;
                        & > h4 {
                            text-align: left;
                            line-height: 2rem;
                            font-weight: 500;
                        }
                    }
                }
                .mask {
                    &:before {
                        opacity: 0.5;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/sustainable/partnership.vue